import { IFilterElement } from "@saleor/components/Filter";
import { maybe, parseBoolean } from "@saleor/misc";
import {
  SoldoutCustomPageFilterKeys,
  SoldoutCustomPageListFilterOpts
} from "@saleor/soldoutcustompage/components/SoldoutCustomPageListPage/filters";
import {
  SoldoutCustomPageListUrlFilters,
  SoldoutCustomPageListUrlFiltersEnum,
  SoldoutCustomPageListUrlQueryParams
} from "@saleor/soldoutcustompage/urls";
import { SoldoutInCustompageFilterInput } from "@saleor/types/globalTypes";
import {
  createFilterTabUtils,
  createFilterUtils,
  getSingleValueQueryParam
} from "@saleor/utils/filters";

export const ATTRIBUTE_FILTERS_KEY = "soldoutCustomPageFilters";

export function getFilterVariables(
  params: SoldoutCustomPageListUrlFilters
): SoldoutInCustompageFilterInput {
  return {
    isPublished:
      params.isPublished !== undefined
        ? parseBoolean(params.isPublished, false)
        : undefined,

    trackInventory:
      params.trackInventory !== undefined
        ? parseBoolean(params.trackInventory, false)
        : undefined,

    search: params.query
  };
}

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  SoldoutCustomPageListUrlQueryParams,
  SoldoutCustomPageListUrlFilters
>(SoldoutCustomPageListUrlFiltersEnum);

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<SoldoutCustomPageListUrlFilters>(
  ATTRIBUTE_FILTERS_KEY
);

export function getFilterOpts(
  params: SoldoutCustomPageListUrlFilters
): SoldoutCustomPageListFilterOpts {
  return {
    isPublished: {
      active: params.isPublished !== undefined,
      value: maybe(() => parseBoolean(params.isPublished, true))
    },
    trackInventory: {
      active: params.trackInventory !== undefined,
      value: maybe(() => parseBoolean(params.trackInventory, true))
    }
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<SoldoutCustomPageFilterKeys>
): SoldoutCustomPageListUrlFilters {
  const { name } = filter;

  switch (name) {
    case SoldoutCustomPageFilterKeys.isPublished:
      return getSingleValueQueryParam(
        filter,
        SoldoutCustomPageListUrlFiltersEnum.isPublished
      );

    case SoldoutCustomPageFilterKeys.trackInventory:
      return getSingleValueQueryParam(
        filter,
        SoldoutCustomPageListUrlFiltersEnum.trackInventory
      );
  }
}
